module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_garage__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@sm360/widget-commons-garage","commonjs2":"@sm360/widget-commons-garage","amd":"@sm360/widget-commons-garage","root":"CommonsGarage"}
// module id = @sm360/widget-commons-garage
// module chunks = widget-6.25.3